angular.module("app").controller("PagesEditPageController", [
    '$scope',
    '$stateParams',
    '$window',
    'pagesService',
    'pageStatuses',
    'pageTypes',
    'preloadedPageData',
    'preloadedPages',
    '$timeout',
    'errorHandler',
    'logger',
    '$state',
    'cropperService',
    'settingsService',
    'deepCompare',
    'userStorage',
    'pagination',
    '$filter',
    'toolsMap',
    '$uibModal',
    'slugNameResolver',
    '$rootScope',
    'parentPageIds',
    'Utils',
    function ($scope, $stateParams, $window, pagesService, pageStatuses, pageTypes, preloadedPageData, preloadedPages, $timeout, errorHandler, logger, $state, cropperService, settingsService, deepCompare, userStorage, pagination, $filter, toolsMap, $modal, slugNameResolver, $rootScope, parentPageIds, Utils) {
        var pendingListRequest;
        $scope.draggedImageDataUrl = "";
        $scope.settings = settingsService.getSettings();
        $scope.actualPageNames = [];
        var pageIds = angular.copy(parentPageIds.parents).reverse();
        pageIds.push($stateParams.pageId);
        $rootScope.breadcrumb = {
            title: "breadcrumb.pages.edit",
            url: "#/pages/pageId/edit/detailed",
            pageIds: pageIds
        };

        $scope.$on("$destroy", function (event) {
            $rootScope.breadcrumb = undefined;
        });
        $scope.actualStatuses = [
            {
                title: 'all',
                value: undefined
            },
            {
                title: 'actual',
                value: true
            },
            {
                title: 'notActual',
                value: false
            }
        ];

        pagesService.getPagesNames({pageType: preloadedPageData.page.type}).then(
            function (response) {
                if (response.status == "ok") {
                    $scope.actualPageNames =  angular.copy(response.pageNames);
                } else {
                    errorHandler(response.message);
                }
            },
            function (error) {
                errorHandler(error.message);
            }
        );

        $scope.userData = userStorage.getUserData();
        $scope.pagination = pagination.init(function () {
            pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                var requestData = {
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                };
                $rootScope.env['pagination' + $stateParams.pageId] = requestData;
                Utils.saveEnvToStorage();
                !!$scope.categoryOptions.categories && (requestData.category_id = $scope.categoryOptions.categories);
                $scope.updateList(requestData)
            }, 300)
        }, preloadedPageData.total_count, 25, $stateParams.pageId);

        $scope.state = $state;
        $scope.tabOptions = {
            showMain: $stateParams.showMain,
            hasItems: $stateParams.hasItems
        };
        $scope.$stateParams = $stateParams;
        $scope.pageStatuses = angular.copy(pageStatuses);
        $scope.pageStatuses.push("expired");
        $scope.filterOptions = {
            status: $rootScope.env['status' + $stateParams.pageId] || $scope.pageStatuses[0],
            actualStatus: undefined
        };
        $scope.pageTypes = pageTypes;
        $scope.allPages = angular.copy(preloadedPages.pages);
        $scope.pristinePageData = angular.copy(preloadedPageData.page) || {};
        $scope.pageData = angular.copy(preloadedPageData.page) || {};
        var typePermissions = {
            'sidebar': "manageBanners",
            'text': "managePages"
        };
        $scope.permission = typePermissions[$scope.pageData.type];
        $scope.pageData.is_analytical = $scope.pageData.is_analytical === '1';
        $scope.ignoreColumns = {
            'id': true,
            'page_id': true,
            'order': true
        };
        !$scope.pageData.customFields && ($scope.pageData.customFields = {
            parent: true,
            children: [

            ]
        });
        $scope.items = $filter('filterPagesTableColumns')(preloadedPageData.items, 2, {show: $scope.pageData.is_analytical, remove: ($scope.pageData.type !== 'sidebar' || $scope.pageData.name !== 'homepage-banners-right') });
        var initialOrders = getValuesByKey($scope.items, 'order');

        $scope.vm = {
            dateTimeFrom: $scope.pageData.start_date || "",
            dateTimeTo: $scope.pageData.end_date || ""
        };

        $scope.categoryOptions = {
            page_id: $scope.pageData.categoryPageId,
            categories: ""
        };

     //   $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());

        if ($scope.pageData.type == "news") {
            pagesService.getCategories({lang: preloadedPageData.page.lang, type: "category"}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.allCategories = angular.copy(response.pages);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );
        }

        $scope.handleChangeOfCategory = function (pageId) {
            if (!!pageId) {
                return pagesService.groupCategory({page_id: pageId}).then(
                    function (response) {
                        if (response.status == "ok") {
                            $scope.categoryItems = angular.copy(response.items);
                            $scope.categoryOptions.categories = ($scope.categoryItems && $scope.categoryItems.length) ? $scope.categoryItems[0].id : "";
                            $scope.handleCategoryChange($scope.categoryOptions.categories)
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            }
            $scope.categoryOptions.categories = "";
            $scope.handleCategoryChange();
        };

        $scope.handleCategoryChange = function (categoryId) {
            if (categoryId) {
                return $scope.updateList({category_id: categoryId})
            }
            $scope.updateList()
        };

        $scope.handleChangeOfSetToAllLanguagesBox = function (isEnabled) {
            if (!isEnabled) {
                $scope.pageData.lang = $scope.pageData.lang || $scope.settings.skin.defaultLang || $scope.settings.skin.languages[0];
            }
        };

        $scope.handleChangeOfPageType = function (type) {
            pagesService.getPagesNames({pageType: type}).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.actualPageNames = angular.copy(response.pageNames);
                        $scope.pageData.name = $scope.actualPageNames[0].name
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )

        };

        $scope.updateList = function (externalOptions) {
            var requestObject = {
                page_id: $stateParams.pageId,
                status: $scope.filterOptions.status,
                limit: $scope.pagination.limit
            };
            $rootScope.env['status' +  $stateParams.pageId] = $scope.filterOptions.status;
            Utils.saveEnvToStorage();

            if ($scope.pageData.type === 'news' && $scope.pageData.setActualBlock) {
                angular.isDefined($scope.filterOptions.actualStatus) && (requestObject.actual = $scope.filterOptions.actualStatus)
            }
            if (externalOptions) {
                requestObject = angular.extend(requestObject, externalOptions)
            }
            $state.$current.name == 'main.pages.editDetailed' && settingsService.setFilters(requestObject);
            pagesService.getPageItems(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        initTools();
                        $scope.items = $filter('filterPagesTableColumns')(response.items, 2, {show: $scope.pageData.is_analytical, remove: ($scope.pageData.type !== 'sidebar' || $scope.pageData.name !== 'homepage-banners-right') });
                        $scope.pagination.totalItems = response.total_count;
                        preloadedPageData.items = angular.copy(response.items);
                        initialOrders = getValuesByKey($scope.items, 'order');
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.submitEditPageForm = function () {

            $scope.preview(function (dataUrl) {

                if ($scope.getChanges() && !$scope.cropped && !$scope.imageDeleted) {
                    return logger.logError("global.no_changes")
                }

                delete $scope.pageData.forceTOChange;
                var requestObj = {
                        page: $scope.pageData
                    },
                    changes;


                if (dataUrl != $scope.draggedImageDataUrl) {
                    if (!$scope.draggedImageDataUrl && !dataUrl && !!requestObj.page.image) {
                        requestObj.page.image = dataUrl || requestObj.page.image;
                    } else {
                        requestObj.page.image = dataUrl || "";
                    }
                }

                if (!$scope.newImageUploaded && !$scope.cropped) {
                    delete requestObj.page.image
                }

                if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
                    delete requestObj.page.image;
                    requestObj.page.media_id = $scope.imageToLoad.id
                }

                if ($scope.imageDeleted) {
                    requestObj.page.image = false;
                }

                !!$scope.vm.fromDate ? (requestObj.page.start_date = $scope.vm.fromDate) : ($scope.fromDateChanged && (requestObj.page.start_date = false));
                !!$scope.vm.toDate ? (requestObj.page.end_date = $scope.vm.toDate) : ($scope.toDateChanged && (requestObj.page.end_date = false));
                changes = deepCompare.getChanges(angular.copy(preloadedPageData.page), requestObj.page, false, {});

                if (!angular.equals(changes.customFields, requestObj.page.customFields)) {
                    changes.customFields = requestObj.page.customFields
                }
                changes.id = requestObj.page.id;

                !requestObj.page.global && (delete changes.global);

                $scope.userData.role === 'skin_news_manager' && delete changes.name;

                pagesService.update({page: changes}).then(
                    function (response) {
                        if (response.status == "ok") {
                            $scope.imageDeleted = false;
                            logger.logSuccess("Page has been successfully updated");
                            preloadedPageData.page = angular.copy($scope.pageData);
                        }
                        else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    }
                );
            });
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.fromDateChanged = true;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.toDateChanged = true;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.pageData.end_date = $scope.vm.toDate;
            }
        };

        $scope.editItem = function (item) {
            $state.go("main.pages.editItem", {pageId: $stateParams.pageId, itemId: item.id})
        };

        $scope.editPage = function (page, hasItems) {

            $state.go("main.pages.editDetailed", {
                pageId: page.id,
                showMain: false,
                hasItems: !!hasItems
            }, {reload: true});
        };

        $scope.deleteItem = function (page) {
            var index = $scope.items.indexOf(page);
            pagesService.deleteItem(page, $stateParams.pageId).then(
                function (response) {
                    if (response.status == "ok") {
                        index != -1 && $scope.items.splice(index, 1);
                        logger.logSuccess("global.itemArchived");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.publishItem = function (page) {
            var index = $scope.items.indexOf(page);
            pagesService.publishItem(page, $stateParams.pageId).then(
                function (response) {
                    if (response.status == "ok") {
                        index != -1 && $scope.items.splice(index, 1);
                        logger.logSuccess("global.itemPublished");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.checkUserRole = function () {
            return $scope.userData.role !== 'skin_news_manager'
        };

        $scope.getChanges = function () {
            if ($scope.newImageUploaded) {
                return false
            }

            return deepCompare.isEqual($scope.pageData, angular.copy(preloadedPageData.page));
        };


        $scope.allowUpdateContainer = {};
        $scope.allowUpdateContainer.allowUpdate = function (options) {
            if (options && options.autoUpdate) {
                reorder();
            } else if (!!options) {
                $scope.tabOptions.reordered = true;
            }
        };
        function reorder () {
            if (typeof $scope.items === "object" && $scope.items.length) {
                reorderByService({
                    ids: getValuesByKey($scope.items, 'id'),
                    orders: initialOrders,
                    parentId: $scope.pageData.id
                }, pagesService);
            }
        }

        function reorderByService (orderData, service) {
            service.changeOrder({
                orderData: orderData
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        cropperService.call($scope);

        $scope.deleteImage = function () {
            $scope.draggedImageDataUrl = $scope.draggedImage = $scope.cropped = undefined;
            $scope.imageDeleted = true;
            $scope.imageToLoad = undefined;
        };


        $scope.listFilterObject = {
            action: function () {
                pendingListRequest && $timeout.cancel(pendingListRequest);
                pendingListRequest = $timeout(function () {
                    var requestData = {
                        current_page: $scope.pagination.page,
                        limit: $scope.pagination.limit
                    };
                    $rootScope.env['pagination' + $stateParams.pageId] = requestData;
                    Utils.saveEnvToStorage();
                    !!$scope.categoryOptions.categories && (requestData.category_id = $scope.categoryOptions.categories);
                    $scope.updateList(requestData);
                });
            }
        };

        /**
         * Init tools when changing status
         */
        function initTools(){
            if (userStorage.getUserData().permissions.indexOf($scope.permission) === -1) {
                return;
            }
            $scope.tools = {
                edit: {
                    action: function (item) {
                        $scope.editItem(item);
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].editToggle.title;
                    }

                },
                inactiveToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].inactiveToggle.action, toolsMap[$scope.filterOptions.status].inactiveToggle.title)
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.title;
                    }
                },
                publishToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].publishToggle.action, toolsMap[$scope.filterOptions.status].publishToggle.title  )
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.title;
                    }
                }
            };
        }

        initTools();

        $scope.toolsAction = function (page, action, title) {
            if (!$scope.checkUserRole()) {
                return
            }
            switch (action){
                case 'delete': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmDeleteAction.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {
                        pagesService.deleteItem(page, $stateParams.pageId).then(
                            function (response) {
                                if (response.status == "ok") {
                                    if ($scope.items.length === 1 && $scope.pagination.page > 1 && ($scope.pagination.page * $scope.pagination.limit >= $scope.pagination.totalItems)) {
                                        $scope.pagination.page = 1;
                                    }
                                    var requestData = {
                                        current_page: $scope.pagination.page,
                                        limit: $scope.pagination.limit
                                    };
                                    !!$scope.categoryOptions.categories && (requestData.category_id = $scope.categoryOptions.categories);
                                    $scope.updateList(requestData);
                                    logger.logSuccess("global.successfullyDeleted");
                                } else {
                                    errorHandler(response.message);
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                            }
                        )

                    });
                    break;
                }
                case 'toggleInactive': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmToggle" + title + "Action.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {
                        pagesService.toggleItemInactive(page, $stateParams.pageId, title !== 'Publish').then(
                            function (response) {
                                if (response.status == "ok") {
                                    if ($scope.items.length === 1 && $scope.pagination.page > 1 && ($scope.pagination.page * $scope.pagination.limit >= $scope.pagination.totalItems)) {
                                        $scope.pagination.page = 1;
                                    }
                                    logger.logSuccess("global.successfullyToggled" + title);
                                    var requestData = {
                                        current_page: $scope.pagination.page,
                                        limit: $scope.pagination.limit
                                    };
                                    !!$scope.categoryOptions.categories && (requestData.category_id = $scope.categoryOptions.categories);
                                    $scope.updateList(requestData)
                                } else {
                                    errorHandler(response.message);
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                            }
                        )

                    });
                    break;
                }

            }


        };
        if ($scope.pageData.type === 'text') {
            $scope.actions = {
                toSubpage: {
                    action: function (item) {
                        $rootScope.env['status' +  item.id] = undefined;
                        $rootScope.env['pagination' + item.id ] = undefined;
                        Utils.saveEnvToStorage();
                        $state.go("main.pages.editDetailed", {pageId: item.id});
                        pagesService.getPageItems({page_id: item.id, limit: 10}).then(
                            function (response) {
                                if (!!response.page.actualNamesPath) {
                                    var  page = response.page;
                                    pagesService.getByExternalPath(response.page.actualNamesPath).then(
                                        function (namesResponse) {
                                            if (namesResponse.status === "ok") {
                                                var result = angular.copy(response);
                                                result.names = angular.copy(namesResponse.pageNames);
                                                if ( result.names.length > 0){
                                                    slugNameResolver.addChild($stateParams.pageId, item.id, page.name);
                                                }
                                                return angular.copy(result)
                                            } else {
                                                slugNameResolver.addChild($stateParams.pageId, item.id);

                                                return angular.copy(response)
                                            }

                                        },
                                        function () {
                                            slugNameResolver.addChild($stateParams.pageId, item.id);
                                            return angular.copy(response)
                                        }
                                    )
                                }
                                slugNameResolver.addChild($stateParams.pageId, item.id);
                                return angular.copy(response);
                            },
                            function (error) {
                                errorHandler(error.message);
                                return null
                            }
                        )
                    }
                }
            };
        }
        /**
         * Update is rotatable in page
         */
        $scope.updateIsAnalytical = function updateIsAnalytical(){
            pagesService.editPage([{id: $scope.pageData.id, is_analytical: $scope.pageData.is_analytical? 1: 0}]).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.updated");
                        $scope.items = $filter('filterPagesTableColumns')(preloadedPageData.items, 2, {show: $scope.pageData.is_analytical, remove: ($scope.pageData.type !== 'sidebar' || $scope.pageData.name !== 'homepage-banners-right') });
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                });
        }


    }
]);
